"use client";

import { FALLBACK_FEATURE_IMAGE } from "@/lib/utils";
import Image, { type ImageProps } from "next/image";
import { useEffect, useState } from "react";

type SafeImageProps = Omit<ImageProps, "src"> & {
  src: ImageProps["src"] | null;
  fallbackSrc?: ImageProps["src"];
};

const SafeImage = ({
  src,
  fallbackSrc = FALLBACK_FEATURE_IMAGE,
  onError,
  ...props
}: SafeImageProps) => {
  const [imageSrc, setImageSrc] = useState(src ?? fallbackSrc);

  useEffect(() => {
    setImageSrc(src ?? fallbackSrc);
  }, [src, fallbackSrc]);

  return (
    <Image
      {...props}
      src={imageSrc}
      alt={props.alt ?? ""}
      onError={(event) => {
        if (imageSrc !== fallbackSrc) {
          setImageSrc(fallbackSrc);
        }

        onError?.(event);
      }}
    />
  );
};

export default SafeImage;
